<template>
  <div id="transactions">
    <div class="row">
      <div class="col-12">
        <h1 class="page-title">{{$t('pages.title.transactions')}}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-6 col-lg-3">
        <multiselect
          v-model="selectedSenderUser"
          deselect-label="Deselect"
          track-by="name"
          label="name"
          :placeholder="$t('transactions.filters.sender')"
          :options="userOptions"
          :searchable="true"
          :allow-empty="true"
          class="sender-select"
          @input="filter"
        >
          <template slot="singleLabel" slot-scope="{ option }">
            <strong>{{ option.name }}</strong>
          </template>
        </multiselect>
      </div>
      <div class="col-6 col-lg-3">
        <multiselect
          v-model="selectedReceiverUser"
          deselect-label="Deselect"
          track-by="name"
          label="name"
          :placeholder="$t('transactions.filters.receiver')"
          :options="userOptions"
          :searchable="true"
          :allow-empty="true"
          class="sender-select"
          @input="filter"
        >
          <template slot="singleLabel" slot-scope="{ option }">
            <strong>{{ option.name }}</strong>
          </template>
        </multiselect>
      </div>
      <div class="col">
        <div class="time-range-wrapper">
          <segmented-control
            class="time-range-segmented-control"
            :options="timeRangeOptions"
            label="label"
            value="value"
            color="#fff"
            active-color="#622D90"
            :multiple="false"
            ref="timeRange"
            @select="timeRangeChanged"
          />
        </div>
      </div>
    </div>
    <transition
      appear
      mode="out-in"
      enter-active-class="animated slideInUp faster"
      leave-active-class="animated fadeOut faster"
    >
      <div class="row transaction-grid" v-if="transactions">
        <div
          class="col-12 col-md-6 col-xl-4"
          v-for="(transaction, index) in transactions"
          :key="index"
        >
          <transaction :transaction="transaction" />
        </div>
        <div
          class="col-12 empty-list"
          v-if="transactions.length == 0"
        >{{$t('transactions.list.empty.title')}}</div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Transaction from './Transaction';

export default {
  name: 'Transactions',
  components: {
    Transaction,
  },
  props: {},
  data() {
    return {
      selectedSenderUser: undefined,
      selectedReceiverUser: undefined,
      timeRangeOptions: [
        { label: this.$t('transactions.filters.week'), value: 0 },
        { label: this.$t('transactions.filters.month'), value: 1 },
        { label: this.$t('transactions.filters.year'), value: 2 },
      ],
      selectedTimeRangeOptionValue: 0,
      transactions: undefined,
    };
  },
  async created() {
    this.fetchUsers();
    this.filter();
  },
  mounted() {
    if (this.$refs.timeRange) {
      this.$refs.timeRange.onSelect(this.timeRangeOptions[0]);
    }
  },
  methods: {
    ...mapActions({
      fetchUsers: 'users/fetchUsers',
      filterTransactions: 'transactions/filter',
    }),
    async filter() {
      this.$gtag.event('feedbackFilter', { filter: this.selectedTimeRangeOptionValue });
      this.transactions = await this.filterTransactions({
        senderUserId: this.selectedSenderUser
          ? this.selectedSenderUser.id
          : undefined,
        receiverUserId: this.selectedReceiverUser
          ? this.selectedReceiverUser.id
          : undefined,
        timeRange: this.selectedTimeRangeOptionValue,
      });
    },
    timeRangeChanged(values) {
      this.selectedTimeRangeOptionValue = values[0].value;
      this.filter();
    },
  },
  computed: {
    ...mapGetters({
      allUsers: 'users/users',
    }),
    userOptions() {
      if (!this.allUsers) {
        return [];
      }
      return this.allUsers.map(x => ({
        id: x._id,
        name: `${x.firstName} ${x.lastName}`,
      }));
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
#transactions {
  padding: 0 3%;
  //min-height: 100vh;
  .multiselect {
    margin-bottom: 15px;
    >>> .multiselect__option--highlight,
    >>> .multiselect__option--highlight::after {
      background: $primary-hover-color;
    }
    &.sender-select {
      width: 100%;
    }
  }
  .time-range-wrapper {
    margin-top: -2px;
    .time-range-segmented-control {
      height: 70%;
    }
  }
  .transaction-grid {
    margin: 20px 0;
  }
  .empty-list {
    background-color: rgba(250, 250, 250, 1);
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 20px;
    font-size: 25px;
  }
}
</style>
